

































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import motion from '@/views/AiiTasks/motion.vue'
import NewMotion from '@/views/AiiTasks/NewMotion.vue'
import AddResurveyMixin from './addResurveyMixin'

@Component({
	components: {
		motion,
		NewMotion,
	},
})
export default class AddMotion extends Mixins(AddResurveyMixin) {}
